var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user)?_c('p',[_vm._v(_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName)+" : "),_c('strong',[_vm._v(_vm._s(_vm.user.email))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }